var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingPersonalDataBackgroundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 531,
    height: 398,
    viewBox: "0 0 531 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.419 396.139C517.419 199.528 318.228 308.899 296.954 124.353C287 38.0001 65 113.5 12 6",
    stroke: "#F9E9E2",
    strokeWidth: 26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M501.157 396.5C519.226 232.055 307.072 320.241 292.977 154.712C278.882 -10.8173 168.5 154 33.9999 50.5",
    stroke: "white",
    strokeWidth: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingPersonalDataBackgroundIcon);
export default __webpack_public_path__ + "static/media/onboarding-personal-data-background-icon.0fd61fd26ba241edf5b2ff00f094d234.svg";
export { ForwardRef as ReactComponent };